(() => {
  'use strict';

  const consentEventName = 'damesly_consent_update';

  const readConsentState = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy) return null;

    const analyticsGranted = privacy.analyticsProcessingAllowed();
    const advertisingGranted = privacy.marketingAllowed();

    return {
      analytics_storage: analyticsGranted ? 'granted' : 'denied',
      ad_storage: advertisingGranted ? 'granted' : 'denied',
      ad_user_data: advertisingGranted ? 'granted' : 'denied',
      ad_personalization: advertisingGranted ? 'granted' : 'denied',
    };
  };

  const publishConsentState = (source) => {
    const consent = readConsentState();

    if (!consent) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: consentEventName,
      consent_source: source,
      ...consent,
    });

    const gtag = function () {
      window.dataLayer.push(arguments);
    };

    gtag('consent', 'update', consent);
  };

  const initialize = () => {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return false;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;

      publishConsentState('shopify_customer_privacy_state');
      document.addEventListener('visitorConsentCollected', () => {
        publishConsentState('shopify_visitor_consent_collected');
      });
    });

    return true;
  };

  if (!initialize()) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        if (!initialize()) {
          window.addEventListener('load', initialize, { once: true });
        }
      },
      { once: true }
    );
  }
})();